import styled, { css } from 'styled-components';
import { InfiniteHits, SearchBox } from 'react-instantsearch-dom';
import colors from '@utils/colors';
import fonts, { weights } from '@utils/fonts';
import { mq } from '@utils/responsive';
import { Heading } from '@components/type';
import { fontStyles } from '../type';

export const Title = styled(Heading)`
  margin-bottom: 16px;
  color: ${colors.B500};
`;

export const Wrapper = styled.div`
  width: 100%;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  padding: 5vh 24px 5vh;
  text-align: center;
`;

export const SearchBody = styled.div`
  ${fontStyles.normal};
  width: 100%;

  ${(props) =>
  props.typeSize === 'small' &&
  css`
      font-size: 14px;
      line-height: 150%;
    `}

  ${(props) =>
    props.typeSize === 'large' &&
    css`
      font-size: 20px;
  `}
`;

export const MhsSearchBox = styled(SearchBox)`
  display: flex;
  align-items: center;
  justify-content: space-between;
  position: relative;
  margin: 8px 0;
  padding: 8px 16px;
  border-top: 3px solid ${colors.B100};
  border-bottom: 3px solid ${colors.B100};

  form {
    width: 100%;
  }

  button {
    display: none;
  }

  .ais-SearchBox-input {
    padding: 8px 4px;
    width: 100%;
    color: ${colors.B500};
    font-family: ${props => fonts(props.theme.locale).SANS_CONDENSED};
    font-size: 20px;
    font-weight: ${weights.BOLD};
    line-height: 120%;
    border: 0;
    outline: 0;

    &::placeholder {
      color: ${colors.B200};
    }
  }
`;

export const MhsInfiniteHits = styled(InfiniteHits)`

  margin: 40px auto;

   .ais-InfiniteHits-item {
      display: flex;
      flex-direction: column;
      justify-content: center;
      position: relative;
      padding: 16px 0;
      border-bottom: 3px solid ${colors.B100};

      ${mq.gtsm`
        padding: 16px 16px;
        border-bottom: 0;

        &::after {
          content: '';
          position: absolute;
          right: 0;
          bottom: 0;
          left: 0;
          border-bottom: 3px solid ${colors.B100};
          transform: translateY(1.5px);
        }
      `}
   }
  // wrapper web/src/components/StoriesGrid/index.js:16
  .ais-InfiniteHits-list {
    padding-bottom: 16px;

    ${mq.gtsm`
      display: grid;
      grid-template-columns: repeat(3, 1fr);
      margin: 0 -16px;
      padding-bottom: 32px;
    `}
  }

  .ais-InfiniteHits-loadMore {
    display: block;
    position: relative;
    z-index: 1;
    padding: 12px 32px;
    margin: 0 auto;
    align-items: center;
    justify-content: center;
    font-family: ${props => fonts(props.theme.locale).SANS};
    font-size: 16px;
    font-weight: ${weights.BOLD};
    line-height: 20px;
    text-align: center;
    text-decoration: none;
    background-color: ${colors.N0};
    border-radius: 8px;
    cursor: pointer;
    outline: 0;
    user-select: none;
    width: auto;
    appearance: none;
    color: ${colors.B500};
    border-color: ${colors.B500};
    background-color: ${colors.B100};

    ${mq.gtsm`
      padding: 16px 48px;
      font-size: 20px;
      line-height: 24px;
    `};
  }
  .ais-InfiniteHits-loadMore--disabled {
    display: none;
  }
`;

export const MhsStats = styled.div`
  text-align: left;

  span {
    font-size: 32px;
    font-family: ${props => fonts(props.theme.locale).SANS_CONDENSED};
    font-weight: ${weights.BOLD};
    line-height: 100%;

    ${mq.gtsm`
      font-size: 48px;
    `}
  }
`;
